import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "customer-forecast-dashboard" }

import { CUSTOMER_TAB_ROUTER_INFO } from '@/customerForecastModule/constants';
import { useRoute } from 'vue-router';
import HeaderArea from '@/corePagesModule/components/HeaderArea.vue';
import { i18n } from '@/i18n';
import { isEqualRouterInfo } from '../domains/routerInfo';
import BusinessListForecastForReceipt from './BusinessListForecastForReceipt.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const tabInfos = [...CUSTOMER_TAB_ROUTER_INFO];

const route = useRoute();
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderArea, {
      title: _unref(t)('forecastForReceipt_title')
    }, null, 8, ["title"]),
    (_unref(route).path.startsWith('/customer/FR'))
      ? (_openBlock(), _createBlock(BusinessListForecastForReceipt, {
          key: 0,
          class: "customer-forecast-dashboard__container"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(tabInfos, (info) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: info.router
          }, [
            (_unref(isEqualRouterInfo)(_unref(route), info))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(info.component), {
                  key: 0,
                  class: "customer-forecast-dashboard__container"
                }))
              : _createCommentVNode("", true)
          ], 64))
        }), 64))
  ]))
}
}

})